<div class="confirmation-delete-modal">
  <div class="confirmation-delete-modal__content">
    <p class="confirmation-delete-modal__title">Descartar hilo</p>
    <p class="confirmation-delete-modal__body">
      Se descartará el hilo por el momento, si llega un nuevo correo, se
      mostrará en la fila de pendientes.
    </p>
  </div>
  <div class="confirmation-delete-modal__buttons">
    <span class="confirmation-delete-modal__button-cancel" (click)="cancel()"
      >Volver</span
    >
    <lib-ui-button
      variant="filled"
      size="s"
      [fullWidth]="false"
      (click)="confirm()"
      label="Descartar"
    ></lib-ui-button>
  </div>
</div>
